const ACTIVE_SERVICE_TTL = 6 * 60 * 60 * 1000
const MAX_ACTIVE_SERVICES = 20
const FINAL_STATUS_IDS = [13, 18]

const normalizeServiceId = (serviceId) => serviceId?.toString()

const isFinalStatus = (serviceData) => {
  const statusId = Number(serviceData?.id_type_status_service || serviceData?.type_status_service?.id)
  return FINAL_STATUS_IDS.includes(statusId)
}

const pruneState = (state) => {
  const now = Date.now()
  const entries = Object.entries(state.services || {})
    .filter(([serviceId, serviceData]) => {
      const lastUpdated = state.lastUpdated?.[serviceId] || 0
      return !isFinalStatus(serviceData) && now - lastUpdated <= ACTIVE_SERVICE_TTL
    })
    .sort(([a], [b]) => (state.lastUpdated?.[b] || 0) - (state.lastUpdated?.[a] || 0))
    .slice(0, MAX_ACTIVE_SERVICES)

  state.services = entries.reduce((acc, [serviceId, serviceData]) => {
    acc[serviceId] = serviceData
    return acc
  }, {})

  state.lastUpdated = entries.reduce((acc, [serviceId]) => {
    acc[serviceId] = state.lastUpdated[serviceId]
    return acc
  }, {})
}

export default {
  namespaced: true,
  state: () => ({
    services: {},
    lastUpdated: {}
  }),
  mutations: {
    setActiveService(state, { serviceId, serviceData }) {
      const normalizedServiceId = normalizeServiceId(serviceId)
      if (!normalizedServiceId || !serviceData || isFinalStatus(serviceData)) {
        if (normalizedServiceId) {
          const newServices = { ...state.services }
          const newLastUpdated = { ...state.lastUpdated }
          delete newServices[normalizedServiceId]
          delete newLastUpdated[normalizedServiceId]
          state.services = newServices
          state.lastUpdated = newLastUpdated
        }
        return
      }

      state.services = { 
        ...state.services, 
        [normalizedServiceId]: serviceData 
      }
      state.lastUpdated = { 
        ...state.lastUpdated, 
        [normalizedServiceId]: Date.now()
      }
      pruneState(state)
    },
    removeActiveService(state, serviceId) {
      const normalizedServiceId = normalizeServiceId(serviceId)
      const newServices = { ...state.services }
      const newLastUpdated = { ...state.lastUpdated }
      
      delete newServices[normalizedServiceId]
      delete newLastUpdated[normalizedServiceId]
      
      state.services = newServices
      state.lastUpdated = newLastUpdated
    },
    clearActiveServices(state) {
      state.services = {}
      state.lastUpdated = {}
    },
    pruneActiveServices(state) {
      pruneState(state)
    }
  },
  getters: {
    getActiveService: (state) => (serviceId) => state.services[normalizeServiceId(serviceId)],
    getAllActiveServices: (state) => state.services,
    getLastUpdated: (state) => (serviceId) => state.lastUpdated[normalizeServiceId(serviceId)],
    hasActiveService: (state) => (serviceId) => !!state.services[normalizeServiceId(serviceId)],
    activeServicesCount: (state) => Object.keys(state.services).length
  }
}
